/**
 * SlimButton
 *
 * @author Pablo Puppo
 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';

const useStyles = makeStyles(() => ({
  button: {
    '& :hover': {
      cursor: 'pointer',
    },
  },
  buttonIcon: {
    fontSize: '1.1rem',
  },
  title: {
    paddingLeft: 5,
  },
}));

/**
 * SlimButton
 * @param onClick {function} : onClick action callback
 * @param title {string} : Button text
 * @returns {JSX.Element}
 */
function SlimButton({
  title,
  onClick,
}) {
  const classes = useStyles();

  return (
    <div
      role="button"
      tabIndex={0}
      className={classes.button}
      onClick={onClick}
      onKeyDown={onClick}
    >
      <EditIcon className={classes.buttonIcon} sx={{ fontSize: '1.0rem' }} />
      <span className={classes.title}>{title}</span>
    </div>
  );
}

SlimButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SlimButton;
